import { Button, Col, Divider, Row, Upload } from "antd";
import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { execute } from "../../../utils/helpers/execute";
import FieldBuilder from "../../form-components/field-builder";
import styles from "./style.module.scss";
import { IUpdateMessageApp } from "../../../models/apps/request";
import AppsContext from "../../../context/apps/context";
import AppsContextProvider from "../../../context/apps/provider";
import AppContext from "../../../context/app/context";
import FormItem from "../../general/form-item";
import Controller from "../../form-components/controller";
import { UploadOutlined } from "@ant-design/icons";
import OldImage from "../../form-components/old-image";

const Form = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { actions, loading } = useContext(AppsContext);
    const { direction } = useContext(AppContext);
    const location = useLocation();
    const { initialValues } = location.state || {};
    const { id } = useParams();

    const methods = useForm<any>({
        defaultValues: {
            message: initialValues?.message,
            image: initialValues?.image || null,
        } as IUpdateMessageApp,
    });

    const { handleSubmit, reset, control, setValue, watch } = methods;
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const imageFile = watch("image");

    useEffect(() => {
        if (initialValues) {
            reset({
                message: initialValues?.message,
                image: initialValues?.image,
            });
        }
    }, [initialValues]);

    const onSubmit = async (data: any) => {
        const formData = new FormData();
        formData.append("message", data.message);
        if (data.image instanceof File) {
            formData.append("image", data.image);
        }

        await execute({
            callback: async () => {
                setLoadingSubmit(true);
                await actions.updateMessageApp(Number(id), formData);
                navigate(-1);
            },
            finallyCallback: () => {
                setLoadingSubmit(false);
            },
            throwException: false,
        });
    };

    return (
        <FormProvider {...methods}>
            <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <span className={styles.title}>{t("update_store")}</span>
                    <Divider className={styles.divider} />
                    <div className={styles.children}>
                        <Row gutter={[16, 8]}>
                            <Col span={24}>
                                <FieldBuilder
                                    name="message"
                                    label={t("message")}
                                    input={{ type: "text-area" }}
                                    rules={{ required: false }}
                                />
                            </Col>
                            <Col span={24}>
                                <FormItem label={t("image")}>
                                    <Controller
                                        name="image"
                                        control={control}
                                        render={({ field }) => (
                                            <Upload
                                                beforeUpload={(file) => {
                                                    setValue("image", file);
                                                    return false;
                                                }}
                                                showUploadList={false}
                                            >
                                                <Button icon={<UploadOutlined />}>Upload Image</Button>
                                            </Upload>
                                        )}
                                    />
                                </FormItem>
                            </Col>
                            {imageFile && imageFile instanceof File && (
                                <p>Selected file: {imageFile.name}</p>
                            )}

                            {initialValues?.image && <OldImage src={`${process.env.REACT_APP_TEST_UPLOAD_FILE_URL}${initialValues?.image}`} />}
                        </Row>
                    </div>
                </div>

                <div>
                    <Divider className={styles.divider} />
                    <div className={styles.formFooter}>
                        <Button onClick={() => navigate(-1)}>{t("cancel")}</Button>
                        <Button loading={loadingSubmit} htmlType="submit" type="primary">
                            {t("save")}
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};

const UpdateMessageAppForm = () => {
    return (
        <AppsContextProvider>
            <Form />
        </AppsContextProvider>
    );
};
export default UpdateMessageAppForm;
